<header>
  <img src="/img/poll_ninja_logo.svg" alt="Poll Ninja Logo" />
</header>

<style>
  header {
    background: #f7f7f7;
    padding: 20px;
    display: flex;
    justify-content: center;
  }
  header img {
    max-width: 180px;
  }
</style>
